import * as types from './types';

const getCollaboratorsInfo = postingId => {
  return {
    type: types.FETCH_COLLABORATORS_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/getUsersWithPermissions`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const updateUserResponsibleBulk = (userId, postingIds) => {
  return {
    type: types.UPDATE_USER_RESPONSIBLE_BULK,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/updatePostingResponsibleBulk`,
      method: 'PUT',
      query: { userId },
      body: { postingIds }
    }
  };
};

export { getCollaboratorsInfo, updateUserResponsibleBulk };
